import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const content = css`
  height: 100%;
`

export const light = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
`

export const dark = (theme: Theme) => css`
  background-color: ${theme.palette.primary.maxContrast};
  color: ${theme.palette.background.main};
`

export const hero = css`
  position: relative;
  overflow: visible;
  z-index: 1;
  border-radius: 0 ${size[80]} 0 0;
  padding: ${size[24]} 0 ${size[24]};
  display: flex;
  flex-direction: column-reverse;

  ${breakpoint.up('smMd')} {
    max-width: ${width.container.large};
    flex-direction: row;
    margin: 0 auto;
    border-radius: 20px 200px;
    align-items: center;
    justify-content: space-between;
    gap: ${size[40]};
    padding: ${size[56]} ${size[32]} 0;
  }
`

export const heroCell = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const cellContent = css`
  display: inline-block;
  align-self: center;
  max-width: ${width.container.standard};
  width: 100%;
  padding: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    margin-left: auto;
    padding: ${size[20]};
  }
`

export const bulletList = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  padding: 0;
  margin: ${size[20]} 0 ${size[32]};
  max-width: 40rem;

  li {
    display: flex;
    align-items: center;
    gap: ${size[12]};
    flex-shrink: 0;
    font-size: ${fontSize.smMd};

    svg {
      fill: none;
    }
  }
`

export const figure = css`
  position: relative;
  flex-grow: 1;
  align-self: stretch;
  overflow: visible;
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;

  ${breakpoint.up('smMd')} {
    margin: 0;
    align-items: center;
    justify-content: flex-start;
    max-width: 50%;
  }
`

export const background = css`
  width: 400px;
  max-width: 100%;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  ${breakpoint.up('smMd')} {
    width: 110%;
    max-width: 690px;
    right: -5%;
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  row-gap: ${size[12]};

  margin: ${size[60]} 0 ${size[24]};

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    column-gap: ${size[24]};
  }
`

export const button = css`
  height: ${size[60]};
`
